module.exports = __webpack_public_path__ + "img/instagram.8f2b7379.svg";